<app-navigation-layout [hideHeader]="true" [hideMenu]="true" [hideNavigation]="true">
  <span main-container>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <h3>{{ 'Thank you for your order' | translate }}</h3>
          <p>{{ 'You will shortly receive an order confirmation by e-mail.' | translate }}</p>
          <h2 *ngIf="showPleaseTakeYouCard">{{ 'Please take you card' | translate }}</h2>
        </div>
      </div>
    </div>
  </span>
</app-navigation-layout>
